import React from 'react';
import { Link } from 'gatsby';
import { Head } from './../../elements/SharedElements';

const Header = (props) => (
    <Head>
        <h2>{props.title}</h2>
        <div className="links">
            <Link to="/">Home</Link>
            <span> / {props.page}</span>
        </div>
    </Head>
)

export default Header;